
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.459 4.54l-1-.998L8.5 7.502l-3.96-3.96-.998.998 3.96 3.96-3.96 3.96.999.998 3.96-3.96 3.959 3.96.999-.999-3.96-3.96 3.96-3.959z","fill":"#fff"}})])
          )
        }
      }
    